import {MediaFile} from '@shopify/hydrogen';
import {
  MediaConnection,
  MediaContentType,
} from '@shopify/hydrogen/storefront-api-types';
import clsx from 'clsx';

type Props = {
  item: MediaConnection['nodes'][0];
  index: number;
  className?: string;
};

export default function ProductMedia({item, className}: Props) {
  switch (item.mediaContentType) {
    case MediaContentType.Image:
      return (
        <>
          <MediaFile
            // @ts-expect-error options should accept className
            className={clsx(className)}
            data={item}
            draggable={false}
            fetchpriority="high"
            tabIndex={0}
          />
        </>
      );
    case MediaContentType.Video:
      return null;
    default:
      return null;
  }
}
